import {
  Box,
  BoxProps,
  styled,
  Typography,
  TypographyProps
} from '@mui/material';

export const StyledDeleteAbsenceMainBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  })
);

export const StyledDeleteAbsenceDialogBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(4),
    alignItems: 'center',
    position: 'relative',
    marginTop: theme.spacing(1)
  })
);

export const StyledDeleteAbsenceDurationBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    display: 'flex',
    gap: theme.spacing(2)
  })
);

export const StyledErrorTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    padding: theme.spacing(0, 2),
    color: theme.palette.error.main
  })
);

export const StyledDeleteAbsenceFooterBox = styled(
  StyledDeleteAbsenceDurationBox
)<BoxProps>(({ theme }) => ({
  justifyContent: 'end',
  marginTop: theme.spacing(6)
}));
